import React from 'react'

const SecondSection = () => {
    return (
        <section className='mt-2'>
            <div className="new-box-shadow " style={{ borderRadius: '13px', backgroundColor: 'white' }}>
                <div className="row p-4">
                    <div className="col-12" >
                        <h3>داستان <span style={{ color: 'red' }}>نیکوتن</span></h3>
                        <hr style={{ color: 'red' }} />
                    </div>
                </div>
                <div className='p-5'>
                    <div style={{ borderBottom: '1px solid red', borderLeft: '1px solid red', position: 'relative' }} className='p-3'>
                        <div style={{ position: 'absolute', top: '-10px', left: '-10px', borderRadius: '100%', backgroundColor: 'red', padding: '10px' }}></div>
                        <div style={{ position: 'absolute', top: '10px', left: '10px' }} className="d-flex flex-column justify-content-center align-items-center">
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>مهر</span>
                            </div>
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>1398</span>
                            </div>
                        </div>
                        <div className="row mt-5 mt-md-0">
                            <div className="col-md-4">
                                <img
                                    src={window.origin + "/WebSide/assets/images/readmapstroy.png"}
                                    alt="nikotan | نیکوتن"
                                    style={{ width: '100%' }}
                                />
                            </div>
                            <div className="col-md-7 d-flex justify-content-center align-items-center text-center text-md-start">
                                <p>
                                    فاز اولیه تحقیقات نیکوتن در مهر ماه 1398 آغاز شد و با توجه به
                                    نتایج به دست آمده ساخت نسخه MVP استارت زده شد.

                                </p>
                            </div>
                        </div>
                    </div>
                    <div style={{ borderBottom: '1px solid red', borderRight: '1px solid red', position: 'relative' }} className='p-4'>
                        <div style={{ position: 'absolute', bottom: '-10px', right: '-10px', borderRadius: '100%', backgroundColor: 'red', padding: '10px' }}></div>
                        <div style={{ position: 'absolute', bottom: '10px', right: '10px' }} className="d-flex flex-column justify-content-center align-items-center">
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>دی</span>
                            </div>
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>1398</span>
                            </div>
                        </div>
                        <div className="row justify-content-end  mb-5 mb-md-0">
                            <div className="col-md-7 d-flex justify-content-center align-items-center order-2 order-md-1 text-center text-md-start">
                                <p>
                                    ساخت نسخه ابتدایی یا MVP در این زمان به پایان رسید. شاید برایتان
                                    جالب باشد که بدانید در نیکوتن ابتدا فقط رزرو سالن های ورزشی انجام
                                    می شد و با توحجه به این خدمت نام قبلی نیکوتن، سالن یاب بود
                                </p>
                            </div>
                            <div className="col-md-4 order-1 order-md-2">
                                <img
                                    src={window.origin + "/WebSide/assets/images/readmapstroy.png"}
                                    alt="nikotan | نیکوتن"
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ borderBottom: '1px solid red', borderLeft: '1px solid red', position: 'relative' }} className='p-3'>
                        <div style={{ position: 'absolute', top: '-10px', left: '-10px', borderRadius: '100%', backgroundColor: 'red', padding: '10px' }}></div>
                        <div style={{ position: 'absolute', top: '10px', left: '10px' }} className="d-flex flex-column justify-content-center align-items-center">
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>آبان</span>
                            </div>
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>1399</span>
                            </div>
                        </div>
                        <div className="row mt-5 mt-md-0">
                            <div className="col-md-4">
                                <img
                                    src={window.origin + "/WebSide/assets/images/readmapstroy.png"}
                                    alt="nikotan | نیکوتن"
                                    style={{ width: '100%' }}
                                />
                            </div>
                            <div className="col-md-7 d-flex justify-content-center align-items-center text-center text-md-start">
                                <p>
                                    در آبان ماه 1399 اولین وبسایت و اپلیکیشن اندروید نیکوتن
                                    در نسخه تجاری شروع به فعالیت کرد. در این نسخه مواردی وجود
                                    داشت که باید باتوجه به نیاز بازار رفع می شد.

                                </p>
                            </div>
                        </div>
                    </div>
                    <div style={{ borderBottom: '1px solid red', borderRight: '1px solid red', position: 'relative' }} className='p-3'>
                        <div style={{ position: 'absolute', bottom: '-10px', right: '-10px', borderRadius: '100%', backgroundColor: 'red', padding: '10px' }}></div>
                        <div style={{ position: 'absolute', bottom: '10px', right: '10px' }} className="d-flex flex-column justify-content-center align-items-center">
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>فروردین</span>
                            </div>
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>1400</span>
                            </div>
                        </div>
                        <div className="row justify-content-end mb-5 mb-md-0">
                            <div className="col-md-7 d-flex justify-content-center align-items-center order-2 order-md-1 text-center text-md-start">
                                <p>
                                    نسخه کاملی از وبسایت و اپلیکیشن اندروید نیکوتن در نسخه تجاری
                                    شروع به فعالیت کرد. در این نسخه قابلیت رزرو سالن های ورزشی،
                                    استخرها و مجموعه های آبی و باشگاه های بدنسازی وجود داشت.

                                </p>
                            </div>
                            <div className="col-md-4 order-1 order-md-2">
                                <img
                                    src={window.origin + "/WebSide/assets/images/readmapstroy.png"}
                                    alt="nikotan | نیکوتن"
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ borderBottom: '1px solid red', borderLeft: '1px solid red', position: 'relative' }} className='p-3'>
                        <div style={{ position: 'absolute', top: '-10px', left: '-10px', borderRadius: '100%', backgroundColor: 'red', padding: '10px' }}></div>
                        <div style={{ position: 'absolute', top: '10px', left: '10px' }} className="d-flex flex-column justify-content-center align-items-center">
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>خرداد</span>
                            </div>
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>1400</span>
                            </div>
                        </div>
                        <div className="row mt-5 mt-md-0">
                            <div className="col-md-4">
                                <img
                                    src={window.origin + "/WebSide/assets/images/readmapstroy.png"}
                                    alt="nikotan | نیکوتن"
                                    style={{ width: '100%' }}
                                />
                            </div>
                            <div className="col-md-7 d-flex justify-content-center align-items-center text-center text-md-start">
                                <p>
                                    فاز اول بازاریابی نیکوتن در شهرهای پایلوت انجام شد و در این فاز با بیش
                                    از 150 مجموعه ورزشی عقد قرارداد صورت گرفت. پس از موفقیت در این
                                    مرحله، کار بهینه سازی وبسایت و اپلیکیشن برای حضور پرقدرت در شهرهای
                                    بزرگ آغاز شد.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div style={{ borderBottom: '1px solid red', borderRight: '1px solid red', position: 'relative' }} className='p-3'>
                        <div style={{ position: 'absolute', bottom: '-10px', right: '-10px', borderRadius: '100%', backgroundColor: 'red', padding: '10px' }}></div>
                        <div style={{ position: 'absolute', bottom: '10px', right: '10px' }} className="d-flex flex-column justify-content-center align-items-center">
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>مهر</span>
                            </div>
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>1400</span>
                            </div>
                        </div>
                        <div className="row justify-content-end mb-5 mb-md-0">
                            <div className="col-md-7 d-flex justify-content-center align-items-center order-2 order-md-1 text-center text-md-start">
                                <p>
                                    نسخه جدید وبسایت و اپلیکیشن ایجاد شد و نیکوتن به طور رسمی وارد
                                    فاز بازاریابی و فروش شد


                                </p>
                            </div>
                            <div className="col-md-4 order-1 order-md-2">
                                <img
                                    src={window.origin + "/WebSide/assets/images/readmapstroy.png"}
                                    alt="nikotan | نیکوتن"
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ borderBottom: '1px solid red', borderLeft: '1px solid red', position: 'relative' }} className='p-3'>
                        <div style={{ position: 'absolute', top: '-10px', left: '-10px', borderRadius: '100%', backgroundColor: 'red', padding: '10px' }}></div>
                        <div style={{ position: 'absolute', top: '10px', left: '10px' }} className="d-flex flex-column justify-content-center align-items-center">
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>آذر</span>
                            </div>
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>1400</span>
                            </div>
                        </div>
                        <div className="row mt-5 mt-md-0">
                            <div className="col-md-4">
                                <img
                                    src={window.origin + "/WebSide/assets/images/readmapstroy.png"}
                                    alt="nikotan | نیکوتن"
                                    style={{ width: '100%' }}
                                />
                            </div>
                            <div className="col-md-7 d-flex justify-content-center align-items-center text-center text-md-start">
                                <p>
                                    بازاریابی در استان خراسان رضوی به اتمام رسید و وارد شهر تهران شدیم
                                </p>
                            </div>
                        </div>
                    </div>
                    <div style={{ borderBottom: '1px solid red', borderRight: '1px solid red', position: 'relative' }} className='p-3'>
                        <div style={{ position: 'absolute', bottom: '-10px', right: '-10px', borderRadius: '100%', backgroundColor: 'red', padding: '10px' }}></div>
                        <div style={{ position: 'absolute', bottom: '10px', right: '10px' }} className="d-flex flex-column justify-content-center align-items-center">
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>دی</span>
                            </div>
                            <div style={{ color: 'red', fontSize: '15px' }}>
                                <span>1400</span>
                            </div>
                        </div>
                        <div className="row justify-content-end mb-5 mb-md-0">
                            <div className="col-md-7 d-flex justify-content-center align-items-center order-2 order-md-1 text-center text-md-start">
                                <p>
                                    تبلیغات و فروش در استان های هدف
                                </p>
                            </div>
                            <div className="col-md-4 order-1 order-md-2">
                                <img
                                    src={window.origin + "/WebSide/assets/images/readmapstroy.png"}
                                    alt="nikotan | نیکوتن"
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SecondSection